import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  styled,
  Typography,
} from "@mui/material";

const SectionLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.8rem",
  fontWeight: 600,
  color: theme.palette.text.secondary,
  textTransform: "uppercase",
  letterSpacing: "0.05em",
  marginBottom: theme.spacing(0.75),
}));

const StyledFormGroup = styled(FormGroup)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: theme.spacing(0.25),
}));

const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(0.5, 1),
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
  transition: "background 0.15s, border-color 0.15s",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "& .MuiFormControlLabel-label": {
    fontSize: "0.82rem",
    lineHeight: 1.3,
  },
  "& .MuiCheckbox-root": {
    padding: theme.spacing(0.4),
  },
}));

export const FormCheckList = ({
  formik,
  name,
  label,
  options = [],
  isDisabled = false,
}) => {
  const selected = formik.values[name] ?? [];
  const error = formik.touched[name] && Boolean(formik.errors[name]);

  const isChecked = (code) => selected.some((item) => item.code === code);

  const handleChange = (option) => {
    const alreadySelected = isChecked(option.code);
    const next = alreadySelected
      ? selected.filter((item) => item.code !== option.code)
      : [...selected, { code: option.code, name: option.name }];

    formik.setFieldValue(name, next);
    if (!formik.touched[name]) formik.setFieldTouched(name, true, false);
  };

  return (
    <Box>
      {label && <SectionLabel>{label}</SectionLabel>}

      {options.length === 0 ? (
        <Typography variant="caption" color="text.disabled">
          No options available.
        </Typography>
      ) : (
        <StyledFormGroup>
          {options.map((option) => (
            <StyledFormControlLabel
              key={option.code}
              label={
                <Box>
                  <Typography
                    fontSize="0.82rem"
                    fontWeight={500}
                    lineHeight={1.2}
                  >
                    {option.code}
                  </Typography>
                  <Typography
                    fontSize="0.72rem"
                    color="text.secondary"
                    lineHeight={1.2}
                  >
                    {option.name}
                  </Typography>
                </Box>
              }
              control={
                <Checkbox
                  size="small"
                  checked={isChecked(option.code)}
                  onChange={() => handleChange(option)}
                  disabled={isDisabled}
                />
              }
              sx={{
                ...(isChecked(option.code) && {
                  borderColor: "primary.main",
                  backgroundColor: (theme) => theme.palette.primary.main + "0D",
                }),
              }}
            />
          ))}
        </StyledFormGroup>
      )}

      {error && (
        <FormHelperText error sx={{ mt: 0.5, ml: 0.5 }}>
          {formik.errors[name]}
        </FormHelperText>
      )}
    </Box>
  );
};
